import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { getsessionuser } from "../Utils/sessions";
import { Alert, Button, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper, Snackbar, TextField } from "@mui/material";
import { CloudUpload, Delete, Save } from "@mui/icons-material";
import { primarycolor } from "../Utils/colors";
import Loadingspinner from "../Components/loading";
import { EditorState, convertFromRaw, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Deleteblogurl, Postblogurl, Updateblogurl } from "../Utils/urls";
import { convertToHTML } from "draft-convert";
import Draggable from "react-draggable";

function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}



const Editblog = ({ oncancelpost, onsuccesspost, blog }) => {



    const user = getsessionuser()
    const [error, setError] = useState(null);
    const [success, setsuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const [deletedialog, setdeletedialog] = useState(false);


    //blog states
    const [phone, setphone] = useState(user?.phone);
    const [title, settitle] = useState(blog.title);
    const [picture, setpicture] = useState('');
    const [picturestring, setpicturestring] = useState(blog.blogurl);
    const imageref = useRef()


    const [editorState, setEditorState] = useState(EditorState.createEmpty())
    const onEditorStateChange = (editorState) => {
        setEditorState(editorState)
    }

    useEffect(() => {

        const formatted = convertFromRaw(JSON.parse(blog?.content))


        const contentState = EditorState.createWithContent(formatted);

        setEditorState(contentState)
    }, [editorState]);




    const submit = () => {
        setLoading(true)
        if (!title) {
            setLoading(false)
            setError("Fill all fields");
        }
        else {
            const date = new Date();
            setError(null)
            axios.post(Updateblogurl, {
                id: blog.id,
                title: title,
                content: JSON.stringify(convertToRaw(editorState.getCurrentContent())),
            }).then(response => {
                setLoading(false)
                if (!response.data.message) {
                    setsuccess(response.data.success)
                    setTimeout(() => {
                        onsuccesspost()
                    }, 3000);
                } else {
                    setError(response.data.message)
                }
                // 
            }).catch(error => {
                setLoading(false)
                setError("Sorry an error occurred,try again later");
                //if(error.response.status === 401 || error.response.status === 400){}

            });
        }
    }


    const deleteblog = () => {
        setdeletedialog(false)
        setLoading(true)
        setError(null)
        axios.post(Deleteblogurl, {
            id: blog.id,
        }).then(response => {
            setLoading(false)
            if (!response.data.message) {
                setsuccess(response.data.success)
                setTimeout(() => {
                    onsuccesspost()
                }, 3000);
            } else {
                setError(response.data.message)
            }
            // 
        }).catch(error => {
            setLoading(false)
            setError("Sorry an error occurred,try again later");
            //if(error.response.status === 401 || error.response.status === 400){}
        });
    }





    const textinputstyles = {
        maxHeight: 20,
        marginRight: 5,
        width: "50%",
        marginBottom: 5,
        fontSize: 10
    }

    const getBase64 = (file, cb) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    return (
        <Container sx={{
            backgroundColor: "white",
            marginTop: 5,
            padding: 5,
            borderRadius: 2
        }} maxWidth="lg">
            {loading && <Loadingspinner />}
            <Dialog
                open={deletedialog}
                onClose={() => setdeletedialog(false)}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    Confirm Deletion!
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this article?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => setdeletedialog(false)}>
                        Cancel
                    </Button>
                    <Button onClick={deleteblog}>Delete</Button>
                </DialogActions>
            </Dialog>
            <Snackbar open={error?.length > 0 && true} autoHideDuration={3000} onClose={() => setError()}>
                <Alert severity="error">{error}</Alert>
            </Snackbar>
            <Snackbar open={success?.length > 0 && true} autoHideDuration={3000} onClose={() => setsuccess()}>
                <Alert severity="success">{success}</Alert>
            </Snackbar>
            <div className="overflowdivwithoutscroll">
                <div className="right2">
                    Blog titie<br />
                    <TextField id="outlined-basic" InputProps={{ maxLength: 12 }} sx={textinputstyles} label="title" variant="outlined" size="small" value={title} onChange={(e) => settitle(e.target.value)} /><br />

                </div>
                <input
                    id="file-upload"
                    type="file"
                    name="fileUpload"
                    onInput={(e) => {
                        getBase64(e.target.files[0], (result) => { setpicturestring(result) })
                        setpicture(e.target.files[0])
                    }}
                    style={{ display: "none" }}
                />
                <label for="file-upload" >
                    <div style={{
                        width: 400
                    }}>
                        <text>Blog main photo</text>
                        {picturestring ?
                            <img src={picturestring} width={400} height={300} /> :
                            <div className="uploaddiv">
                                <CloudUpload size={70} color="silver" /><br />
                                <text style={{ color: "silver" }}>Drag the file here, or Click to upload </text>
                            </div>
                        }
                    </div>
                </label>
                <div><b>Content</b></div>
                <div >
                    <Editor
                        editorState={editorState}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorClassName"
                        // initialContentState={editorState}
                        onEditorStateChange={onEditorStateChange}
                    />
                </div>
                <br /><br />

            </div>
            <br />
            <div className="bottom2">
                {error && <div className="error">{error}</div>}
                <Button variant="outlined" disabled={!picturestring || !title || !editorState && true} startIcon={<Save />} onClick={submit}>
                    Save
                </Button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Button variant="outlined" startIcon={<Delete />} onClick={() => setdeletedialog(true)}>
                    DELETE
                </Button><br />
            </div>
        </Container>
    );
}

export default Editblog;